import { render, staticRenderFns } from "./ScannerBlock.vue?vue&type=template&id=e8867832&scoped=true"
import script from "./ScannerBlock.vue?vue&type=script&lang=js"
export * from "./ScannerBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8867832",
  null
  
)

export default component.exports